"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _textfield = _interopRequireDefault(require("britive-design-system/core/components/textfield"));

var _snackbar = _interopRequireDefault(require("britive-design-system/core/components/snackbar"));

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _isNumeric = _interopRequireDefault(require("utils/isNumeric"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = ".step-up-checkout-step-up-modal-footer {\n  position: absolute;\n  bottom: 30px; }\n\n.step-up-checkout-step-up-modal-footer-user-setting-link {\n  color: var(--brand);\n  display: inline;\n  cursor: pointer; }\n\n.step-up-checkout-webauthn {\n  display: flex;\n  align-items: center; }\n  .step-up-checkout-webauthn span {\n    font-weight: 600;\n    margin-right: 10px; }\n\n.step-up-checkout-otp {\n  display: flex; }\n  .step-up-checkout-otp button {\n    margin-top: 46px; }\n  .step-up-checkout-otp .bds-textfield-container .bds-input-container {\n    margin-right: 10px;\n    height: 2rem; }\n\n.step-up-divider-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 40px 0px 30px 0; }\n\n.step-up-divider-line {\n  flex-grow: 1;\n  height: 1px;\n  background-color: #ddd;\n  border: none;\n  margin: 0 10px; }\n\n.step-up-divider-text {\n  color: #333;\n  font-size: 14px;\n  font-weight: bold; }\n";
  var fileName = "compone_index";
  var element = document.querySelector("style[data-sass-component='compone_index']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var CSS_CLASSNAME_PREFIX = 'step-up';

var StepUpModal = function StepUpModal(_ref) {
  var _mfaAuthenticate$erro, _mfaAuthenticate$erro2;

  var secretMode = _ref.secretMode,
      mfaAuthenticate = _ref.mfaAuthenticate,
      onClose = _ref.onClose,
      _ref$availableMfaMode = _ref.availableMfaModes,
      availableMfaModes = _ref$availableMfaMode === void 0 ? [] : _ref$availableMfaMode,
      validateOtp = _ref.validateOtp,
      validateWebAuthn = _ref.validateWebAuthn;
  var history = (0, _reactRouterDom.useHistory)();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      mfaOtp = _useState2[0],
      setMfaOtp = _useState2[1]; // Checking if the otp contains only numeric values.


  var isValidOtp = function isValidOtp() {
    return (0, _isNumeric.default)(mfaOtp);
  };

  var isOtpEnabled = availableMfaModes.includes(_constants.mfaFactor.totp);
  var isWebAuthnEnabled = availableMfaModes.includes(_constants.mfaFactor.webAuthN);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: 480,
    title: 'Step-up Verification',
    buttons: [{
      text: 'Cancel',
      variant: 'secondary',
      size: 'medium',
      onClick: function onClick() {
        return onClose(false);
      }
    }],
    onCancel: function onCancel() {
      return onClose(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, (((_mfaAuthenticate$erro = mfaAuthenticate.error) === null || _mfaAuthenticate$erro === void 0 ? void 0 : _mfaAuthenticate$erro.length) > 0 || mfaAuthenticate.result === 'FAILED') && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_snackbar.default, {
    errorList: [((_mfaAuthenticate$erro2 = mfaAuthenticate.error) === null || _mfaAuthenticate$erro2 === void 0 ? void 0 : _mfaAuthenticate$erro2.length) > 0 ? mfaAuthenticate.error : 'Invalid OTP']
  }), /*#__PURE__*/_react.default.createElement("br", null)), isWebAuthnEnabled && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-checkout-webauthn")
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, "Use WebAuthn"), /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: validateWebAuthn
  }, secretMode === 'edit' ? 'Edit Secret' : 'View Secret', " with WebAuthn")), (availableMfaModes === null || availableMfaModes === void 0 ? void 0 : availableMfaModes.length) > 1 && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-divider-container")
  }, /*#__PURE__*/_react.default.createElement("hr", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-divider-line")
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-divider-text")
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, "OR")), /*#__PURE__*/_react.default.createElement("hr", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-divider-line")
  })), isOtpEnabled ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-checkout-otp")
  }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
    label: isOtpEnabled && isWebAuthnEnabled ? 'Use OTP instead' : 'Use OTP',
    helperText: "Please Enter OTP from your Authenticator app",
    value: mfaOtp,
    width: "245px",
    onChange: function onChange(e) {
      return setMfaOtp(e.target.value);
    },
    onKeyUp: function onKeyUp(e) {
      return e.key === 'Enter' ? validateOtp(mfaOtp) : null;
    },
    error: mfaOtp !== null && mfaOtp !== void 0 && mfaOtp.length ? !isValidOtp() : false,
    errorMsg: mfaOtp !== null && mfaOtp !== void 0 && mfaOtp.length && !isValidOtp() ? 'Invalid OTP' : ''
  }), /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: function onClick() {
      return validateOtp(mfaOtp);
    },
    disabled: (mfaOtp === null || mfaOtp === void 0 ? void 0 : mfaOtp.length) < 4 || !isValidOtp()
  }, secretMode === 'edit' ? 'Edit Secret' : 'View Secret', " with OTP"))) : null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-checkout-step-up-modal-footer")
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, "Not registered your MFA? Please register it under the ", /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-checkout-step-up-modal-footer-user-setting-link"),
    onClick: function onClick() {
      return history.push('/user-settings');
    }
  }, "User Settings"))))), mfaAuthenticate.isAuthenticating ? /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "medium",
    message: "",
    overlay: true
  }) : null);
};

StepUpModal.propTypes = {
  secretMode: _propTypes.default.string,
  mfaAuthenticate: _propTypes.default.object,
  onClose: _propTypes.default.func,
  authenticateStepUpMFA: _propTypes.default.func,
  availableMfaModes: _propTypes.default.arrayOf(_propTypes.default.string),
  validateOtp: _propTypes.default.func,
  validateWebAuthn: _propTypes.default.func
};
var _default = StepUpModal;
exports.default = _default;